import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--checkout-billing"
export default class extends Controller {
    connect() {
        //console.log('CheckoutBillingController connected');
        // Delay initialization to ensure DOM is fully ready
        setTimeout(() => {
            this.initializeValidation();
        }, 100);
    }

    initializeValidation() {
        const form = document.getElementById('frm-checkout-billing');
        if (!form) {
            console.error('Checkout billing form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'order[bill_firstname]': {
                    validators: {
                        notEmpty: {
                            message: 'The first name is required'
                        }
                    }
                },
                'order[bill_lastname]': {
                    validators: {
                        notEmpty: {
                            message: 'The last name is required'
                        }
                    }
                },
                'order[bill_dayphone]': {
                    validators: {
                        notEmpty: {
                            message: 'The telephone number is required.'
                        }
                    }
                },
                'order[bill_address1]': {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required.'
                        }
                    }
                },
                'order[bill_city]': {
                    validators: {
                        notEmpty: {
                            message: 'The city is required.'
                        }
                    }
                },
                'order[bill_state]': {
                    validators: {
                        notEmpty: {
                            message: 'The State is required.'
                        }
                    }
                },
                'order[bill_zipcode]': {
                    validators: {
                        notEmpty: {
                            message: 'The zip code is required.'
                        }
                    }
                },
                'order[cc_number]': {
                    validators: {
                        notEmpty: {
                            message: 'The credit card number is required'
                        },
                        creditCard: {
                            message: 'The credit card number is not valid!'
                        }
                    }
                },
                'order[cc_month]': {
                    validators: {
                        notEmpty: {
                            message: 'The credit card expiration month is required'
                        }
                    }
                },
                'order[cc_year]': {
                    validators: {
                        notEmpty: {
                            message: 'The credit card expiration year is required'
                        }
                    }
                },
                'order[cc_code]': {
                    validators: {
                        notEmpty: {
                            message: 'The CVV number is required'
                        },
                        cvv: {
                            creditCardField: 'order[cc_number]',
                            message: 'The CVV number is not valid!'
                        }
                    }
                }
            },
            plugins: {
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.fv-row',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                }),
                // Exclude hidden fields from validation
                excluded: new plugins.Excluded({
                    excluded: function (field, element, elements) {
                        // Don't validate billing address fields if they're in a hidden collapse section
                        const billingCollapse = element.closest('#billing-address-div');
                        if (billingCollapse && !billingCollapse.classList.contains('show')) {
                            return true;
                        }

                        // Don't validate if the field is in a hidden payment method section
                        const paymentContent = element.closest('.payment-method-content');
                        if (paymentContent) {
                            // Check if this specific payment content div is hidden
                            const isHidden = window.getComputedStyle(paymentContent).display === 'none';
                            if (isHidden) {
                                return true;
                            }
                        }

                        return false;
                    }
                })
            }
        })
            .on('core.form.valid', function (e) {
                // Form is valid, submit it
                //console.log('Form is VALID - submitting');
                form.submit();
            })
            .on('core.form.invalid', function (e) {
                // Form is invalid, prevent submission
                //console.log('Form is INVALID - preventing submission');
            })
            .on('core.validator.validated', function (e) {
                //console.log('Field validated:', e.field, 'Result:', e.result);
            });

        // Store the FormValidation instance on the form element
        form._formValidation = this.validation;
        
        //console.log('Validator initialized successfully');

        // Listen for country changes to handle dynamic state field
        const countrySelect = form.querySelector('#order_bill_country');
        if (countrySelect) {
            countrySelect.addEventListener('change', () => {
                this.handleCountryChange();
            });
        }

        // Listen for payment method changes to revalidate
        const paymentRadios = form.querySelectorAll('input[name="order[payment_type]"]');
        paymentRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                // Revalidate the form when payment method changes
                // The Excluded plugin will automatically skip hidden fields
                if (this.validation) {
                    this.validation.resetForm();
                }
            });
        });
    }

    /**
     * Handle country change to revalidate the state field
     */
    handleCountryChange() {
        if (!this.validation) return;

        const fieldName = 'order[bill_state]';

        // Reapply validation to the state field after country changes
        setTimeout(() => {
            try {
                this.validation.removeField(fieldName);
            } catch (e) {
                console.warn('Field was not yet registered for validation', e);
            }

            this.validation.addField(fieldName, {
                validators: {
                    notEmpty: {
                        message: 'The State is required.'
                    }
                }
            });
        }, 100);
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
